import { Loading } from '@ui/components';
import { FC } from 'react';

export const Suspense: FC = () => {
  return <Loading className="w-screen h-screen" element="main" />;
};
